import { AnyAction } from '@reduxjs/toolkit';
import { SELECT_CUSTOMER } from '../action-types';
import type { ISelectCustomerAction } from '../actions';
import type { ICustomerSelectedState } from '../interfaces';

export const initialState: ICustomerSelectedState = {
  customerId: null,
};

export const customerSelectedReducer = (
  state: ICustomerSelectedState = initialState,
  action: AnyAction,
): ICustomerSelectedState => {
  switch (action.type) {
    case SELECT_CUSTOMER:
      return {
        ...state,
        customerId: (action as ISelectCustomerAction).payload,
      };
    default:
      return state;
  }
};
